import React from 'react'
import ImageWrapper from './ImageWrapper'
import { navigate } from 'gatsby'

const AppleStoreButton = ({ MaxWidth }) => {
    
    const redirectPath = () => {
        navigate('https://apps.apple.com/us/app/ielts-ninja/id1640213849')
    }

    return (
        <>
            <button className='apple_store_btn'style={{maxWidth: `${MaxWidth}px`}} onClick={redirectPath}>
                <ImageWrapper ImgUrl={"https://s3.us-east-2.wasabisys.com/ufaber-lms/files/e54b5d7eb2ffb9b959da4e4cd9aba77a.svg"} />
            </button>
        </>
    )
}

export default AppleStoreButton